"use client"

import type { Meeting } from "@/schema"
import { useGlobalSlideoverStore } from "@/stores/use-global-slideover-store"
import { Button, DropdownMenuItem } from "@ui/shad"
import { History } from "lucide-react"

import { AuditLogEntry } from "@/components/audit-logs/audit-log-access"
import { Link } from "@/components/book-link"

export function MeetingAuditLogLink({ meeting, menuItem = false }: { meeting: Meeting; menuItem?: boolean }) {
  const link = (
    <Link
      href={`/audit-log/meeting/${meeting.id}`}
      bookIdOverride={meeting.book_id}
      onClick={() => useGlobalSlideoverStore.getState().closeSlideover()}
    >
      <History />
      View audit log
    </Link>
  )

  return (
    <AuditLogEntry>
      {menuItem ? (
        <DropdownMenuItem asChild>{link}</DropdownMenuItem>
      ) : (
        <Button asChild variant="ghost" size="sm">
          {link}
        </Button>
      )}
    </AuditLogEntry>
  )
}
